const styles = {
  container: {
    display: 'flex',
    overflowX: 'auto',
    height: '80vh',
    padding: 2,
    gap: 2,
    '&::-webkit-scrollbar': { display: 'none' },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },
};

export default styles;
